import * as Yup from 'yup';

export const agencyHolidaysSchema = Yup.object().shape({
    holidays: Yup.array().required('Pflichtfeld'),
});
